module.exports = __webpack_public_path__ + "static/media/gravitus-details.87fa7cde.jpg";